import { ReactNode } from 'react'
import useHook from './hooks'
import style from './style.module.scss'
import Lander from './lander'
import Supplier from './supplier'
import { OrderType } from '../../tools/public'
import { Tabs } from 'antd'
import { GetLocalStorage } from '../../tools/util'
export default function ReturnManagement() {
  const { checkedOrderKey, changeOrder } = useHook()

  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] =
    GetLocalStorage('COOPERATETYPE') === '1'
      ? [
          {
            key: 'SUPPLIER',
            component: <Supplier />,
            title: '供应商订单',
          },
        ]
      : GetLocalStorage('COOPERATETYPE') === '2'
        ? [
            {
              key: 'CUSTOMER',
              component: <Lander />,
              title: '电商供应商订单',
            },
          ]
        : [
            {
              key: 'CUSTOMER',
              component: <Lander />,
              title: '电商供应商订单',
            },
            {
              key: 'SUPPLIER',
              component: <Supplier />,
              title: '供应商订单',
            },
          ]

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={style.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane tab={item.title} key={item.key}>
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}
import { ReactNode } from 'react'
import useHook from './hooks'
import style from './style.module.scss'
import Lander from './lander'
import Supplier from './supplier'
import { OrderType } from '../../tools/public'
import { Tabs } from 'antd'
import { GetLocalStorage } from '../../tools/util'
export default function ReturnManagement() {
  const { checkedOrderKey, changeOrder } = useHook()

  const menuList: {
    key: OrderType
    component: ReactNode
    title: string
  }[] =
    GetLocalStorage('COOPERATETYPE') === '1'
      ? [
          {
            key: 'SUPPLIER',
            component: <Supplier />,
            title: '供应商订单',
          },
        ]
      : GetLocalStorage('COOPERATETYPE') === '2'
        ? [
            {
              key: 'CUSTOMER',
              component: <Lander />,
              title: '电商供应商订单',
            },
          ]
        : [
            {
              key: 'CUSTOMER',
              component: <Lander />,
              title: '电商供应商订单',
            },
            {
              key: 'SUPPLIER',
              component: <Supplier />,
              title: '供应商订单',
            },
          ]

  const getMainContent = (key: string) => {
    return menuList.find((item) => item.key === key)?.component
  }

  return (
    <div className={style.main}>
      <Tabs
        type="card"
        activeKey={checkedOrderKey}
        onTabClick={(keyname) => {
          changeOrder(keyname)
        }}
      >
        {menuList.map((item) => {
          return (
            <Tabs.TabPane tab={item.title} key={item.key}>
              {getMainContent(item.key)}
            </Tabs.TabPane>
          )
        })}
      </Tabs>
    </div>
  )
}
